// extracted by mini-css-extract-plugin
export default {"section":"Tq-z","inSectionButton":"Uq-z","addressCard":"Vq-z","disabled":"Wq-z","cautionBox":"Xq-z","failureBox":"Yq-z","fade-out":"Zq-z","successBox":"_q-z"};